<template>
    <b-container fluid>
        <hr/>
        <h3>Webhooks</h3>
        <hr/>
        <b-button-group>
            <v-btn v-b-modal.create_webhook_modal :style="primaryStyle" :loading="loadingCreate"
                   :disabled="loadingCreate">New webhook
            </v-btn>
        </b-button-group>
        <hr/>
        <v-skeleton-loader
                :loading="this.loadingIndex"
                transition='fade-transition'
                ref="skeleton"
                type="table"
                class="mx-auto"
                width="100%">
            <b-table striped :items="webhooks"
                     :fields="['id', 'name', 'project_name', 'path', 'event_name',  'active', 'edit', 'description_&_URL', 'delete']">
                <template slot="path" slot-scope="data">
                    <template v-if="data.item.path.length >= 35">{{data.item.path.slice(0,35)}}...</template>
                    <template v-else>{{data.item.path}}</template>
                </template>
                <template slot="edit" slot-scope="data">
                    <b-button @click="editWebhook(data.item)" variant="primary">Edit</b-button>
                </template>
                <template slot="description_&_URL" slot-scope="data">
                    <b-button @click="showDescription(data.item)" variant="secondary">Description & full URL
                    </b-button>
                </template>
                <template slot="delete" slot-scope="data">
                    <b-button @click="deleteWebhook(data.item)" variant="danger">Delete</b-button>
                </template>
            </b-table>
        </v-skeleton-loader>

        <v-dialog v-model="webhookDetailsPopUp" max-width="50%" class="taskDetailDialog">
            <v-card>
                <v-toolbar flat>
                    <v-toolbar-title>Details</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon @click="webhookDetailsPopUp = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-divider style="margin: 0"/>
                <v-tabs vertical :color="sitionColor" class="taskDetailTabs">
                    <v-tab>description</v-tab>
                    <v-tab>url</v-tab>
                    <v-tab-item class="taskDetailTabItem">
                        <v-card flat>
                            <v-card-text>
                                <p class="dialogText">{{webhookDetails.notes_and_description}}</p>
                            </v-card-text>
                        </v-card>
                    </v-tab-item>
                    <v-tab-item class="taskDetailTabItem">
                        <v-card flat>
                            <v-card-text>
                                <p class="dialogText">{{webhookDetails.fullURL}}</p>
                            </v-card-text>
                            <v-card-actions>
                                <input type="hidden" id="urlForWebhook" :value="webhookDetails.fullURL">
                                <b-btn class="btn btn-primary btn-sm" v-on:click="copyURL">copy URL</b-btn>
                            </v-card-actions>
                        </v-card>
                    </v-tab-item>
                </v-tabs>
            </v-card>
        </v-dialog>

        <create v-bind:projects="projects"
                v-bind:project_options="project_options"
                v-bind:event_options="event_options"
                @webhook-created="WebhookCreated"
                @change-create-loading="loadingCreate = !loadingCreate">
        </create>
        <edit v-bind:selected_webhook="to_edit_webhook"
              v-bind:event_options="event_options"
              @webhook-edited="WebhookEdited"
              @show-loading-pop-up="showLoadingPopUp"
              @reset-loading-pop-up="resetLoadingPopUp">
        </edit>
    </b-container>
</template>

<script>
    import WebhookRepository from '../../repositories/webhook.repository';
    import Create from "./Create";
    import Edit from "./Edit";

    export default {
        components: {
            Create,
            Edit,
        },
        data() {
            return {
                projects: [],
                events: [],
                webhooks: [],
                to_edit_webhook: WebhookRepository.blankWebhook(),
                to_edit_webhook_id: -1,
                to_edit_webhook_name: '',
                to_edit_webhook_blocks: [],
                loadingIndex: false,
                loadingCreate: false,
                webhookDetailsPopUp: false,
                webhookDetails: {description: '', url: ''}
            }
        },
        created() {
            this.loadingIndex = true;
            WebhookRepository.getIndexData().then(res => {
                if (res.data.success) {
                    this.projects = res.data.projects;
                    this.events = res.data.events;
                    this.webhooks = res.data.webhooks;
                } else window.console.log('Looks like something went wrong...');
                this.loadingIndex = false;
            }).catch(error => {
                this.loadingIndex = false;
            });
        },
        methods: {
            showLoadingPopUp(text) {
                this.$emit('show-loading-pop-up', text);
            },
            resetLoadingPopUp() {
                this.$emit('reset-loading-pop-up');
            },
            showDescription(webhook) {
                this.webhookDetails = Object.assign({}, webhook);
                this.webhookDetailsPopUp = true;
            },
            WebhookCreated(webhook) {
                this.webhooks.push(webhook);
            },
            WebhookEdited(webhook) {
                this.webhooks.forEach(w => {
                    if (w.id === webhook.id) Object.assign(w, webhook);
                });
            },
            editWebhook(webhook) {
                // Clone the selected item so that it can be edited without changing the original.
                this.to_edit_webhook = Object.assign({}, webhook);
                // Show the edit modal.
                this.$bvModal.show('edit_webhook_modal');
            },
            deleteWebhook(webhook) {
                this.$emit('show-loading-pop-up', 'Deleting the selected webhook.');
                WebhookRepository.delete(webhook.id).then(res => {
                    this.$emit('reset-loading-pop-up');
                    // Status 204 means no content, which is the response we would expect when deleting a record.
                    if (res.status === 204) {
                        // Remove the Webhook from the local list to reflect the deletion.
                        this.webhooks = this.webhooks.filter(s => s.id !== webhook.id);
                        // Notify the user.
                        this.$bvToast.toast(`Webhook ${webhook.name} successfully deleted.`, {
                            title: `Webhook deleted.`,
                            variant: 'success',
                            solid: true
                        });
                    } else {
                        // If the status is not 204 something must have gone wrong.
                        // So we notify the user with a toast.
                        this.$bvToast.toast('Looks like something went wrong while deleting a Webhook.', {
                            title: `Webhook deletion error.`,
                            variant: 'danger',
                            solid: true
                        });
                    }
                });
            },
            copyURL() {
                let URLToCopy = document.querySelector('#urlForWebhook');
                URLToCopy.setAttribute('type', 'text');
                URLToCopy.select();

                try {
                    let successful = document.execCommand('copy');
                    URLToCopy.setAttribute('type', 'hidden');
                    if (successful) {
                        this.$bvToast.toast('The URL is succesfully copied to the clipboard.', {
                            title: `URL copied.`,
                            variant: 'success',
                            solid: true
                        });
                    } else {
                        this.$bvToast.toast('Oops, unable to copy, pls. refresh the page and try again.', {
                            title: `Can't copy.`,
                            variant: 'danger',
                            solid: true
                        });
                    }
                } catch (err) {
                    alert('Oops, unable to copy');
                    this.$bvToast.toast('Oops, unable to copy, pls. refresh the page and try again.', {
                        title: `Can't copy.`,
                        variant: 'danger',
                        solid: true
                    });
                }
            }
        },
        computed: {
            project_options() {
                return this.projects.map(p => {
                    return {value: p.id, text: p.id + " - " + p.name};
                });
            },
            event_options() {
                return this.events.map(e => {
                    return {value: e.name, text: e.name};
                });
            }
        }
    }
</script>
